import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
`;

export const FilterComponentSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 28px;
    padding-right: 28px;
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBottom : 'unset'};
    &:hover {
        cursor: pointer;
    }
`;

export const FilterComponentLabels = styled.label`
    display: flex;
    font-family: AvenirNextWorld Regular;
    font-size: 15px;
    align-items: center;
    width: 100%;
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
		width: 100vw;
		max-width: none;
    `}
`;

export const FilterLabel = styled.div`
    text-align: left;
    font-family: AvenirNextWorld Regular;
    letter-spacing: -0.12px;
    color: #000000;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 15px;
    word-break: break-word !important;
    word-break: break-all;

    width: ${(props) => (props.width ? props.width : 'unset')};
    white-space: ${(props) => (props.whiteSpace ? props.whiteSpace : 'unset')};
    overflow: ${(props) => (props.overFlow ? props.overFlow : 'unset')};
    text-overflow: ${(props) =>
        props.textOverflow ? props.textOverflow : 'unset'};

    @media only screen and (max-device-width: 360px) {
        width: ${(props) => props.smbWidth && props.smbWidth};
    }
`;

export const DefaultIndicator = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 10px;
    color: #e5047e;
    margin-left: 10px;
    border: 1px solid #e5047e;
    border-radius: 3px;
    width: ${({ width }) => (width ? width : '47px')};
    height: 18px;
    display: flex;
    justify-content: center;
`;

export const RadioButton = styled.img`
    margin-right: 25px;
`;
